/* oxlint-disable */
'use client';

import React, { Suspense, useEffect, useState } from 'react';

// import JackpotContent from '@/features/casino/components/JackpotContent';

import { getJackpot } from '@/sanity/sanity-utils';


// import LoadingSpinner from '../../components/common/LoadingSpinner';
import { ComingSoonPage } from '@/components/common/ComingSoonPage';

export default function JackpotsLobby() {
  const [backgroundImage, setBackgroundImage] = useState<string>('/img/background/torneobackground.webp');

  useEffect(() => {
    const cmsJackpotFetch = async () => {
      const getCmsJackpot = await getJackpot();
      setBackgroundImage(getCmsJackpot[0]?.imageLanding);
    };
    cmsJackpotFetch();
  }, [backgroundImage]);
  return (
    <>
      {/* {backgroundImage && (
        <div className="relative flex flex-col items-stretch sm:pl-8 pb-5 max-w-full overflow-hidden bg-[url('/img/background/Jackpots-bg.webp')] bg-cover bg-center bg-no-repeat z-0">
          <h1 className="sr-only">Gran tesoro de la Bahía - Powerbet</h1>
          {/* <Suspense fallback={<LoadingSpinner />}>
            <JackpotContent />
          </Suspense> */}
        {/* </div> */}
       {/* )} */}
       <ComingSoonPage title="Jackpots" />
    </>
  );
}
